import React from 'react';

import { useTranslation } from 'react-i18next';

import { useEditor } from '@craftjs/core';

import { Box, Button, Alert } from '@mui/material';
import { EDITOR_RESOLVERS } from '@common/constants';
import {
  selectBackgroundColor,
  selectTypographyColor,
} from '@common/providers/ThemeProvider/selectors';

const getSelectedPanel = (state, query) => {
  const currentSelectedNodes = [];

  state?.events?.selected?.forEach((item) => currentSelectedNodes.push(item));
  let selected;

  if (currentSelectedNodes.length) {
    let currentSelected = currentSelectedNodes[0];
    if (state?.nodes[currentSelected])
      selected = {
        id: currentSelected,
        name: state?.nodes[currentSelected]?.data?.name,
        settings:
          state?.nodes[currentSelected]?.related &&
          state?.nodes[currentSelected]?.related?.settings,
        isDeletable: query?.node(currentSelected)?.isDeletable(),
      };
  }

  return { selected };
};

const ConfigPanel = () => {
  const { actions, selected } = useEditor(getSelectedPanel);
  const { t } = useTranslation();

  return selected ? (
    <Box
      sx={{
        backgroundColor: selectBackgroundColor,
        color: selectTypographyColor,
      }}
    >
      {selected?.settings && React.createElement(selected?.settings)}
      {selected?.isDeletable &&
        selected?.name !== EDITOR_RESOLVERS.COMMON.TABLE_ROW &&
        selected?.name !== EDITOR_RESOLVERS.COMMON.TABLE_HEADER &&
        selected?.name !== EDITOR_RESOLVERS.COMMON.TABLE_FOOTER &&
        selected?.name !== EDITOR_RESOLVERS.COMMON.TABLE_CELL && (
          <Button
            sx={{ m: 1, mt: 2 }}
            variant='outlined'
            color='error'
            onClick={() => {
              const selectedId = selected?.id;
              actions?.delete(selectedId);
              actions?.selectNode(null);
            }}
          >
            {t('delete_btn')}
          </Button>
        )}
    </Box>
  ) : (
    <Alert sx={{ mt: 1 }} severity='info'>
      {t('no_component_selected_message')}
    </Alert>
  );
};

export default ConfigPanel;
